export const mediaContainerType = {
  PROJECT: 'PROJECT',
  CHANNEL: 'CHANNEL',
};
export const localStorageLastAllContentLocationKey = 'wistia:lastAllContentLocation';
export const createModalUploaderId = 'CREATE_MODAL';
export const googleCheckUserConnectionEndpoint = '/google/oauth/check_user_connection';
export const googleRevokeConnectionEndpoint = '/google/oauth/revoke_user_connection';
export const googleAuthFlowEndpoint = '/google/oauth/pre_auth';
export const DEFAULT_ASPECT_RATIO = 16 / 9; // eslint-disable-line @typescript-eslint/no-magic-numbers
